import Flex from '@eversports/react-components/primitives/Flex'
import Text from '@eversports/react-components/primitives/Text'
import { usePyroField } from 'pyro-form'
import React, { useCallback } from 'react'

import useCheckoutContext from '../../data/useCheckoutContext'
import { Localized } from '../../localization/react'
import { StoredCreditCard as StoredCreditCardType } from '../../typings/Payment'

import StoredCreditCard from './StoredCreditCard'

interface Props {
  creditCards: Array<StoredCreditCardType>
}

const StoredCreditCards: React.FC<React.PropsWithChildren<Props>> = ({ creditCards }) => {
  const { core } = usePyroField('cardId')
  const context = useCheckoutContext()

  const handleClick = useCallback(() => {
    context.setIsPaymentValid(true)
  }, [])

  return (
    <Flex flexDirection="column" verticalSpacing="default" fullWidth>
      <Text size="small">
        <Localized id="payment-pay-with-credit-card-saved-credit-cards" />
      </Text>
      <Flex flexDirection="column" verticalSpacing="dense" onClick={handleClick} fullWidth>
        {creditCards.map((card) => (
          <StoredCreditCard key={card.id} card={card} isSelected={core.value === card.pspId} />
        ))}
      </Flex>
    </Flex>
  )
}

export default StoredCreditCards
